import React, { Component } from 'react';
import PropTypes from 'prop-types';
import getNoteByChapterKey from '../utils/getNoteByChapterKey';
import { SecondaryTitle, CardContent, CardSpacing } from './CommonUiComponents';
import ExpandableItem, { ExpandableItemContent } from './ExpandableItem';
import Note, { noteType } from './Note';
import ErrorBoundary from './ErrorBoundary';

class Notes extends Component {
  componentWillMount() {
    const { fetchNotes } = this.props;
    fetchNotes();
  }

  render() {
    const { notes, parts, fetchNotes } = this.props;

    return (
      <ErrorBoundary>
        <CardSpacing hugger>
          <CardContent>
            <SecondaryTitle highlight>Mine notater</SecondaryTitle>
          </CardContent>
        </CardSpacing>
        {parts.map(part => (
          <ExpandableItem key={part.key} label={part.name}>
            <ExpandableItemContent>
              {part.chapters.map((chapter, k) => (
                <ExpandableItem
                  key={chapter.key}
                  label={`Kaptittel ${k + 1}`}
                  alternate
                >
                  <ExpandableItemContent alternate>
                    <Note
                      data={getNoteByChapterKey(notes, chapter.key)}
                      chapterKey={chapter.key}
                      fetchNotes={fetchNotes}
                    />
                  </ExpandableItemContent>
                </ExpandableItem>
              ))}
            </ExpandableItemContent>
          </ExpandableItem>
        ))}
      </ErrorBoundary>
    );
  }
}

Notes.propTypes = {
  fetching: PropTypes.bool.isRequired,
  notes: PropTypes.arrayOf(noteType.isRequired).isRequired,
  parts: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      chapters: PropTypes.arrayOf(
        PropTypes.shape({
          key: PropTypes.number.isRequired
        }).isRequired
      ).isRequired
    }).isRequired
  ).isRequired,
  fetchNotes: PropTypes.func.isRequired
};

export default Notes;



// WEBPACK FOOTER //
// ./src/components/Notes.js